import { Injectable } from '@angular/core';
import {
  FaxBackAccount,
  FaxBackResponse,
  FaxBackSummary,
} from '../../../../models/faxback.model';
import { DomainTableData } from '../../shared/types/domain-data.types';
import { FaxAuditTableService } from './fax-audit-table.service';

@Injectable({
  providedIn: 'root',
})
export class FaxAuditMapperService {
  constructor(private readonly tableService: FaxAuditTableService) {}

  mapResponseToTableData(
    response: FaxBackResponse,
  ): DomainTableData<FaxBackAccount>[] {
    return response.summary.map((summary: FaxBackSummary) => {
      const accounts = this.filterAccountsByDomain(
        response.accounts,
        summary.domainId,
      );
      return this.tableService.createTableData(summary.domainId, accounts);
    });
  }

  private filterAccountsByDomain(
    accounts: FaxBackAccount[],
    domainId: string,
  ): FaxBackAccount[] {
    return accounts.filter((account) => account.domainId === domainId);
  }
}
